module.exports = __webpack_public_path__ + "img/vodafone-nok-ad.7c2d0942.jpg";